module.exports = __webpack_public_path__ + "img/SQZP.10babe5d.png";